//
// Copyright 2026 ArangoDB GmbH, Cologne, Germany
// All rights reserved. See LICENSE.md in the project root for license information.
//
import { TaxClassification } from "../../api/lib";

// The API serializes enums as their string name (e.g. "TAX_CLASSIFICATION_EU_CORPORATION"),
// while the generated TS enum is numeric — normalize before displaying, or it never matches.
const normalizeTaxClassification = (raw: unknown): TaxClassification | undefined => {
  if (raw == null || raw === "") {
    return undefined;
  }
  if (typeof raw === "number") {
    return raw as TaxClassification;
  }
  const byName = TaxClassification[raw as keyof typeof TaxClassification];
  return typeof byName === "number" ? byName : undefined;
};

// Human-readable label for a tax classification (accepts the API string or the numeric enum).
export const taxClassificationLabel = (raw: unknown): string => {
  switch (normalizeTaxClassification(raw)) {
    case TaxClassification.TAX_CLASSIFICATION_INDIVIDUAL:
      return "Individual (private person)";
    case TaxClassification.TAX_CLASSIFICATION_EU_CORPORATION:
      return "EU Corporation";
    default:
      return "";
  }
};
